import React from "react";
import Loader from "react-loader-spinner";

const Spinner = (props) => {
  return (
    (
        props.show && <div className="spinner">
          <div>
            <Loader type="Circles" color="#15558d" height="100" width="100" />
          </div>
        </div>
    )
        
  );
};

export default Spinner;